<template>
  <canvas class="detailed-mode-chart-root" ref="placeholder"></canvas>
</template>

<script>
import Chart from 'chart.js'
import 'chartjs-plugin-annotation'

function _formatDate(date) {
  const y = date.getFullYear()
  const m = date.getMonth() + 1
  const d = date.getDate()
  const h = date.getHours()
  return `${y}-${m}-${d}T${h}:00:00`
}

const _indicatorRanges = new Map([
  ['TEMP', { min: 15, max: 35 }],
  ['HUM', { min: 10, max: 80 }],
  ['CO2', { min: 250, max: 2000 }],
  ['VOC', { min: 0, max: 3500 }],
  ['PART', { min: 0, max: 6 }]
])

function _createAnnotation(value) {
  return {
    type: 'line',
    mode: 'horizontal',
    scaleID: 'y-axis-0',
    value: value,
    borderColor: 'rgb(255, 168, 12)',
    borderWidth: 3,
    label: {
      enabled: false
    }
  }
}

export default {
  name: 'DetailedModeChart',
  props: ['indicatorItem', 'indicatorContainerId'],
  data: () => {
    let to = new Date()
    let hours = to.getHours()
    if (to.getMinutes() !== 0) {
      hours++
    }
    to = new Date(to.getFullYear(), to.getMonth(), to.getDate(), hours)

    return {
      dateTo: to,
      chart: null
    }
  },
  mounted() {
    if (this.indicatorItem) {
      this.refreshChart()
    }
  },
  beforeUpdate() {
    if (this.chart) {
      this.chart.destroy()
      this.chart = null
    }
  },
  updated() {
    if (this.indicatorItem) {
      this.refreshChart()
    }
  },
  watch: {
    indicatorItem: function() {
      // 'Watch' is necessary because VueJS does not refresh a component
      // when a property is not used in the HTML template.
      if (this.chart) {
        this.chart.destroy()
        this.chart = null
      }
      if (this.indicatorItem) {
        this.refreshChart()
      }
    }
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.destroy()
      this.chart = null
    }
  },
  methods: {
    async refreshChart() {
      if (this.chart) {
        debugger
      }

      const rawValues = await this.$fetch(
        `container/${this.indicatorContainerId}?DateFrom=${_formatDate(
          this.dateFrom
        )}&DateTo=${_formatDate(this.dateTo)}`
      )

      const indicatorValues = rawValues.find(
        x => x.DataType === this.indicatorItem.data.DataType
      ).Datas

      const chartData = indicatorValues.map(x => x.Value)
      const chartLabels = indicatorValues.map(x => x.Date)

      const yRange = _indicatorRanges.get(this.indicatorItem.data.DataType)

      // Extend display range based on actual data if necessary
      yRange.min = Math.min(yRange.min, ...chartData)
      yRange.max = Math.max(
        this.indicatorItem.resource.Threshold1 * 1.1,
        this.indicatorItem.resource.Threshold2 * 1.1,
        yRange.max,
        ...chartData)

      const annotation = []
      if (this.indicatorItem.resource.Threshold1 > 0) {
        annotation.push(
          _createAnnotation(this.indicatorItem.resource.Threshold1)
        )
      }
      if (this.indicatorItem.resource.Threshold2 > 0) {
        annotation.push(
          _createAnnotation(this.indicatorItem.resource.Threshold2)
        )
      }

      if (this.chart) {
        this.chart.destroy()
      }

      this.chart = new Chart(this.$refs.placeholder, {
        type: 'line',
        data: {
          labels: chartLabels,
          datasets: [
            {
              label: 'values',
              fill: false,
              data: chartData,
              borderColor: 'darkgray',
              pointRadius: 0,
              lineTension: 0
            }
          ]
        },
        options: {
          aspectRatio: this.$isMobile ? 1.2 : 2,
          legend: {
            display: false
          },
          tooltips: {
            enabled: false
          },
          scales: {
            xAxes: [
              {
                type: 'time',
                time: {
                  unit: 'hour',
                  displayFormats: {
                    hour: 'DD/MM HH:mm'
                  }
                },
                ticks: {
                  minRotation: 45
                }
              }
            ],
            yAxes: [
              {
                id: 'y-axis-0',
                ticks: {
                  min: yRange.min,
                  max: yRange.max
                }
              }
            ]
          },
          annotation: {
            annotations: annotation
          }
        }
      })
    }
  },
  computed: {
    dateFrom: function() {
      return new Date(this.dateTo.getTime() - 24 * 3600 * 1000)
    }
  }
}
</script>

<style lang="less">
@import '../app.less';

.detailed-mode-chart-root {
  .desktop-media({max-width: 60vw;});
  margin-top: 1rem;
}
</style>


// WEBPACK FOOTER //
// src/components/DetailedModeChart.vue